import { useEffect, useState } from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment-timezone'
import { string, func } from 'prop-types'

const styles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}))

let timezoneLocal = ''

const availableTimezones = [
  'America/Puerto_Rico',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Phoenix',
  'America/Los_Angeles',
  'America/Anchorage',
  'Pacific/Honolulu',
  'Asia/Kolkata',
]

export const FindTimezone = (timezoneFromParent) => {
  if (!timezoneFromParent || timezoneFromParent === '') {
    let localTimezone = moment.tz.guess()
    if (availableTimezones.includes(localTimezone)) {
      return localTimezone
    }
    timezoneLocal = <MenuItem value={localTimezone}>{localTimezone}</MenuItem>
    availableTimezones.push(localTimezone)
    return localTimezone
  }
  return timezoneFromParent
}

const SelectTimezoneItem = (props) => {
  const classes = styles(props)
  const { timezoneFromParent, callbackFromParentTimezone } = props

  const [selectedTimezone, setSelectedTimezone] = useState(
    FindTimezone(timezoneFromParent),
  )

  useEffect(() => {
    if (!selectedTimezone) {
      setSelectedTimezone(FindTimezone(timezoneFromParent))
    } else if (selectedTimezone !== timezoneFromParent) {
      callbackFromParentTimezone(selectedTimezone)
    }
  }, [selectedTimezone, timezoneFromParent, callbackFromParentTimezone, props])

  const handleChange = (event) => {
    setSelectedTimezone(event.target.value)
    callbackFromParentTimezone(event.target.value)
  }

  return (
    <div>
      <FormControl className={classes.formControl}>
        <InputLabel id="timezone-label">Time Zone</InputLabel>
        <Select
          labelId="timezone-label"
          value={selectedTimezone}
          onChange={handleChange}
        >
          <MenuItem value={'America/Puerto_Rico'}>
            Puerto Rico (Atlantic)
          </MenuItem>
          <MenuItem value={'America/New_York'}>New York (Eastern)</MenuItem>
          <MenuItem value={'America/Chicago'}>Chicago (Central)</MenuItem>
          <MenuItem value={'America/Denver'}>Denver (Mountain)</MenuItem>
          <MenuItem value={'America/Phoenix'}>Phoenix (MST)</MenuItem>
          <MenuItem value={'America/Los_Angeles'}>
            Los Angeles (Pacific)
          </MenuItem>
          <MenuItem value={'America/Anchorage'}>Anchorage (Alaska)</MenuItem>
          <MenuItem value={'Pacific/Honolulu'}>Honolulu (Hawaii)</MenuItem>
          <MenuItem value={'Asia/Kolkata'}>India (IST)</MenuItem>
          {timezoneLocal}
        </Select>
      </FormControl>
    </div>
  )
}

export default SelectTimezoneItem

SelectTimezoneItem.propTypes = {
  timezoneFromParent: string.isRequired,
  callbackFromParentTimezone: func.isRequired,
}
